// extracted by mini-css-extract-plugin
export default {"fr-view":"ImageContainer_fr-view__MOuzx","container":"ImageContainer_container__s0rXw","image":"ImageContainer_image__hALbG"};